module.exports = __webpack_public_path__ + "media/src/ui/images/iconMobileSmall-a118ca19ee9e062ca58c3ce585d41ec0.svg";